import { GoogleSheetsListPage } from '@pwa/components/integrations/google-sheets-list-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/org/$orgId/integrations/google-sheets/')({
	component: RouteComponent,
});

function RouteComponent() {
	const { orgId } = Route.useParams();
	return <GoogleSheetsListPage orgId={orgId} />;
}
